import { render, staticRenderFns } from "./iconDevolutions.vue?vue&type=template&id=20519590&scoped=true"
import script from "./iconDevolutions.vue?vue&type=script&lang=js"
export * from "./iconDevolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20519590",
  null
  
)

export default component.exports